// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"8a5a4373","775":"8a5a4373","887":"d41713f0"}[chunkId] + ".chunk.css";
};